import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { LifeBuoy, Mail, Phone, MessageSquare } from "lucide-react";
import {
  NavigationMenu,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
  navigationMenuTriggerStyle,
} from "@/components/ui/navigation-menu";

const Support = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-gray-100">
      <nav className="border-b bg-white/80 backdrop-blur-sm sticky top-0 z-50">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <Link to="/" className="text-xl font-bold text-gray-900">
              SecureFiles
            </Link>
            
            <NavigationMenu>
              <NavigationMenuList>
                <NavigationMenuItem>
                  <Link to="/who-we-are">
                    <NavigationMenuLink className={navigationMenuTriggerStyle()}>
                      Who We Are
                    </NavigationMenuLink>
                  </Link>
                </NavigationMenuItem>
                <NavigationMenuItem>
                  <Link to="/support">
                    <NavigationMenuLink className={navigationMenuTriggerStyle()}>
                      Support
                    </NavigationMenuLink>
                  </Link>
                </NavigationMenuItem>
                <NavigationMenuItem>
                  <Link to="/login">
                    <NavigationMenuLink className={navigationMenuTriggerStyle()}>
                      Login
                    </NavigationMenuLink>
                  </Link>
                </NavigationMenuItem>
              </NavigationMenuList>
            </NavigationMenu>
          </div>
        </div>
      </nav>

      <div className="max-w-6xl mx-auto px-4 py-16 sm:px-6 lg:px-8">
        <div className="text-center space-y-8">
          <h1 className="text-4xl font-bold tracking-tight text-gray-900 sm:text-6xl">
            Support Center
          </h1>
          <p className="text-lg leading-8 text-gray-600 max-w-2xl mx-auto">
            We're here to help! Choose from our various support channels below.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            <div className="flex flex-col items-center p-8 bg-white rounded-lg shadow-sm">
              <Mail className="h-10 w-10 text-primary mb-4" />
              <h3 className="text-lg font-semibold">Email Support</h3>
              <p className="text-sm text-gray-500 text-center mt-2">
                Send us an email anytime
              </p>
              <Button className="mt-4">
                support@example.com
              </Button>
            </div>

            <div className="flex flex-col items-center p-8 bg-white rounded-lg shadow-sm">
              <Phone className="h-10 w-10 text-primary mb-4" />
              <h3 className="text-lg font-semibold">Phone Support</h3>
              <p className="text-sm text-gray-500 text-center mt-2">
                Available Monday-Friday, 9am-5pm
              </p>
              <Button className="mt-4">
                1-800-123-4567
              </Button>
            </div>

            <div className="flex flex-col items-center p-8 bg-white rounded-lg shadow-sm">
              <MessageSquare className="h-10 w-10 text-primary mb-4" />
              <h3 className="text-lg font-semibold">Live Chat</h3>
              <p className="text-sm text-gray-500 text-center mt-2">
                Chat with our support team
              </p>
              <Button className="mt-4">
                Start Chat
              </Button>
            </div>

            <div className="flex flex-col items-center p-8 bg-white rounded-lg shadow-sm">
              <LifeBuoy className="h-10 w-10 text-primary mb-4" />
              <h3 className="text-lg font-semibold">Help Center</h3>
              <p className="text-sm text-gray-500 text-center mt-2">
                Browse our documentation
              </p>
              <Button className="mt-4">
                Visit Help Center
              </Button>
            </div>
          </div>

          <div className="mt-8">
            <Link to="/">
              <Button variant="outline">Back to Home</Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Support;